<template>
  <div class="ProgramActivity-list-page w-100">
    <basic-subheader>
      <template v-slot:actions>
        <b-row class="align-items-center flex-nowrap">
          <!-- Filter dropdown button - auto width -->
          <b-col cols="auto" class="pr-2">
            <b-dropdown
              id="dropdown-right dropdown-form"
              class="dropdown-form-filter"
              no-caret
              right
            >
              <template #button-content>
                <span class="svg-icon">
                  <inline-svg src="/media/svg/icons/Neolex/Basic/filter.svg" />
                </span>
                Bộ lọc
              </template>
              <h6 class="d-flex align-items-center mb-0 p-4">
                <span class="svg-icon mr-3">
                  <inline-svg src="/media/svg/icons/Neolex/Basic/filter.svg" />
                </span>
                Bộ lọc
              </h6>
              <b-dropdown-divider></b-dropdown-divider>
              <b-dropdown-form>
                <!-- Filter form content remains the same -->
                <b-container class="p-0">
                  <b-row class="mb-3">
                    <b-col cols="4">
                      <basic-input
                        label="Tên hoạt động"
                        placeholder="Nhập tên hoạt động"
                        name="code"
                        :value.sync="filter.name"
                      ></basic-input>
                    </b-col>
                    <b-col cols="4">
                      <basic-select
                        placeholder="Chọn loại hoạt động"
                        :options="
                          setupData.Types.map((item) => ({
                            text: item.Name,
                            value: item.Id,
                          }))
                        "
                        class="w-100"
                        track-by="value"
                        value-label="text"
                        label="Loại hoạt động"
                        :value.sync="filter.ActivityTypeId"
                      ></basic-select>
                    </b-col>
                    <b-col cols="4">
                      <basic-select
                        placeholder="Chọn chủ đề"
                        :options="
                          setupData.Topics.map((item) => ({
                            text: item.Name,
                            value: item.Id,
                          }))
                        "
                        class="w-100"
                        track-by="value"
                        value-label="text"
                        label="Chủ đề"
                        :value.sync="filter.ActivityTopicId"
                      ></basic-select>
                    </b-col>
                    <b-col cols="5">
                      <basic-select
                        label="Cấp độ"
                        placeholder="Chọn cấp độ của hoạt động"
                        name="subject"
                        :value.sync="filter.ProgramActivityLevelId"
                        :options="
                          setupData.Levels.map((item) => ({
                            text: item.Name,
                            value: item.Id,
                          }))
                        "
                        track-by="value"
                        value-label="text"
                      ></basic-select>
                    </b-col>

                    <b-col cols="3">
                      <basic-select
                        label="Trạng thái hoạt động"
                        placeholder="Chọn trạng thái"
                        name="status"
                        track-by="value"
                        value-label="text"
                        :value.sync="filter.status"
                        :options="status"
                      ></basic-select>
                    </b-col>
                  </b-row>
                  <!-- Other filter rows remain the same -->
                </b-container>
              </b-dropdown-form>
              <b-dropdown-divider></b-dropdown-divider>
              <div
                class="d-flex align-items-center justify-content-lg-end m-0 p-4"
              >
                <b-button
                  class="btn ml-2"
                  href="#"
                  tabindex="0"
                  @click="resetRequest"
                >
                  <span class="svg-icon">
                    <inline-svg
                      src="/media/svg/icons/Neolex/Basic/refresh-cw.svg"
                    />
                  </span>
                  Reset bộ lọc
                </b-button>
                <b-button
                  class="btn ml-2"
                  href="#"
                  tabindex="0"
                  @click="searchRequest"
                >
                  <span class="svg-icon">
                    <inline-svg
                      src="/media/svg/icons/Neolex/Basic/filter.svg"
                    />
                  </span>
                  Lọc dữ liệu
                </b-button>
              </div>
            </b-dropdown>
          </b-col>

          <!-- Select dropdown - flexible width -->
          <!-- <b-col cols="auto" class="px-2" style="min-width: 200px;">
            <div style="height:85px; display: flex; align-items: flex-end;">
              <basic-select placeholder="Chọn loại hoạt động"
                :options="data.map(item => ({ text: item.name, value: item.id }))" class="w-100" track-by="value"
                value-label="text"></basic-select>
            </div>
          </b-col> -->

          <!-- Add new button - auto width -->
          <b-col cols="auto" class="pl-2">
            <b-button v-if="isInsertPermission" class="btn btn-success" type="button" @click="createItem">
              <span class="svg-icon">
                <inline-svg src="/media/svg/icons/Neolex/Basic/plus.svg" />
              </span>
              Thêm mới
            </b-button>
          </b-col>
        </b-row>
      </template>
    </basic-subheader>
    <b-overlay :show="loading">
      <b-container fluid class="ProgramActivity-list-page__body mb-6 mt-6">
        <b-row>
          <b-col>
            <div class="card card-custom gutter-b">
              <div class="card-body mt-0">
                <template-table
                  :column="column"
                  :data="data"
                  :paging="paging"
                  :tableAction="false"
                  :selectAction="false"
                  :searchAction="false"
                  @search="searchRequest"
                  @reset="resetRequest"
                  @sortBy="sortRequest"
                >
                  <template v-slot:body="{ item, index }">
                    <td>
                      {{ (paging.page - 1) * paging.pageSize + index + 1 }}
                    </td>
                    <td class="text-center">
                      {{ item.code }}
                    </td>
                    <td :class="getPositionClass(item.name)">
                      {{ item.name }}
                    </td>
                    <td>
                      {{
                        setupData.Levels.find(
                          (x) => x.Id == item.programActivityLevelId,
                        ).Name
                      }}
                    </td>
                    <td>
                      {{ updateSelectedActivityTopic(item.activityTopicId) }}
                    </td>

                    <td>
                      {{ item.allowReminder ? 'Cho phép' : 'Không' }}
                    </td>
                    <td class="status">
                      <div class="status" :class="getStatus(item.status)">
                        {{ item.status == 0 ? 'Hoạt động' : 'Không hoạt động' }}
                      </div>
                    </td>
                    <td style="width: 20px">
                      <action-dropdown
                        :value="item"
                        :show_delete="false"
                        :show_copy="false"
                        :show_edit="false"
                        @view="viewItem(item)"
                        @delete="deleteItem(item)"
                      >
                        <b-dropdown-text
                          tag="div"
                          class="navi-item cursor-pointer"
                        >
                          <a
                            class="navi-link text-primary"
                            @click.stop="deleteItem(item)"
                          >
                            <span class="menu-icon svg-icon svg-icon-sm">
                              <inline-svg
                                class="svg-icon"
                                :class="
                                  item.status ? 'text-primary' : 'text-danger'
                                "
                                src="/media/svg/icons/Neolex/Basic/power.svg"
                              />
                            </span>
                            <span
                              :class="
                                item.status ? 'text-primary' : 'text-danger'
                              "
                            >
                              {{
                                item.status ? 'Hoạt động' : 'Không hoạt động'
                              }}
                            </span>
                          </a>
                        </b-dropdown-text>
                      </action-dropdown>
                    </td>
                  </template>
                </template-table>
                <ModalCreateDetail
                  ref="modalCreate"
                  :setupData="setupData"
                  @loadData="loadData"
                  :selectedItem="selectedItems"
                ></ModalCreateDetail>

                <div v-if="false">Check</div>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </b-overlay>
  </div>
</template>

<script>
import { TAG_TYPE } from '../../../core/plugins/constants';
import moment from 'moment';

export default {
  name: 'ProgramActivityList',
  components: {
    ModalCreateDetail: () =>
      import('./components/modal/ModalCreateActivity.vue'),
  },
  data() {
    return {
      status: [
        {
          value: 0,
          text: 'Hoạt động',
        },
        {
          value: 1,
          text: 'Không hoạt động',
        },
      ],
      paging: {
        page: 1,
        pageSize: 10,
        total: 0,
      },
      filter: {
        code: null,
        name: null,
        activityTypeId: null,
        programActivityLevelId: null,
        activityTopicId: null,
        activityDisplayDayId: null,
        subject: null,
        reminderNumbers: null,
        detailLink: null,
        redirectLink: null,
        videoLink: null,
        status: null,
        displayIndex: null,
      },
      sort: {
        by: 'DisplayIndex',
        order: 'asc',
      },
      column: [
        {
          key: 'STT',
          label: 'STT',
          sortable: false,
        },
        {
          key: 'Code',
          label: 'Mã',
          sortable: false,
          class: 'text-center',
        },
        {
          key: 'name',
          label: 'Tên hoạt động',
          sortable: false,
        },
        {
          key: 'level',
          label: 'Cấp độ',
          sortable: false,
        },

        {
          key: 'subject',
          label: 'Loại hoạt động',
          sortable: false,
        },
        {
          key: 'redirectLink',
          label: 'Thông báo nhắc nhở',
          sortable: false,
        },
        {
          key: 'status',
          label: 'Trạng thái',
          sortable: false,
          class: 'text-center',
        },
        {
          key: '',
          label: '',
          sortable: false,
        },
      ],
      data: [],
      setupData: [],
      loading: false,
      selectedItems: [],
      selectedRemindersId: [],
    };
  },
  computed: {
    searchParams() {
      const payload = this.removeEmpty({
        name: this.filter.name,
        ActivityTypeId: this.filter.ActivityTypeId,
        activityTopicId: this.filter.ActivityTopicId,
        programActivityLevelId: this.filter.ProgramActivityLevelId,
        status: this.filter.status,
        page: this.paging.page,
        size: this.paging.pageSize,
      });

      const params = new URLSearchParams();
      for (const property in payload) {
        params.append(property, payload[property]);
      }

      return params;
    },
  },
  watch: {
    'paging.page'() {
      this.loadData();
    },
    'paging.pageSize'() {
      this.loadData();
    },
    filter: {
      deep: true,
    },
  },
  methods: {
    convertDateToTimestamp(date) {
      return date ? moment(date).unix() : null;
    },

    updateSelectedActivityTopic(newItem) {
      const selectedTopic = this.setupData.Topics.find(
        (topic) => topic.Id === newItem,
      );
      return selectedTopic ? selectedTopic.Name : '';
    },
    searchRequest() {
      this.loadData();
      document.body.click();
    },
    resetRequest() {
      (this.filter.name = null),
        (this.filter.ActivityTopicId = null),
        (this.filter.ProgramActivityLevelId = null),
        (this.filter.ActivityTypeId = null),
        (this.filter.status = null),
        this.loadData();
      document.body.click();
    },
    sortRequest(sortData) {
      this.sort = {
        by: sortData.column,
        order: sortData.order,
      };
      this.loadData();
    },
    async viewItem(item) {
      await this.loadDataReminders(item.id);
      this.selectedItems = {
        ...item,
        action: 'view',
        reminders: this.selectedRemindersId,
      };
      this.$refs.modalCreate.openModal();
    },
    editItem(item) {
      this.$router.push({
        name: 'program_activity_edit',
        params: {
          id: item.id,
          form_type: 'edit',
        },
      });
    },

    getPositionClass(value) {
      if (typeof value === 'number' && !isNaN(value)) {
        return 'text-right'; // Number
      } else if (typeof value === 'string') {
        return 'text-left'; // String
      } else if (
        (Object.prototype.toString.call(value) === '[object Date]' &&
          !isNaN(value)) ||
        !isNaN(Date.parse(value))
      ) {
        return 'text-center';
      } else {
        return 'text-right';
      }
    },
    createItem() {
      this.selectedItems = { action: 'create' };
      this.$refs.modalCreate.openModal();
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        this.veeFields[ref].dirty &&
        this.veeFields[ref].validated
      ) {
        return this.veeFields[ref].valid;
      }
      return null;
    },
    importItems() {
      this.$bvModal.show('modal-import');
    },
    deleteItem(item) {
      let btn = item.status == 0 ? 'btn-active' : 'btn-inactive';
      let textStatusB = item.status ? 'Hoạt động' : 'Không hoạt động';
      let textStatusA = !item.status ? 'Hoạt động' : 'Không hoạt động';
      this.$swal({
        title: '',
        text: `Bạn có chắc chắn muốn chuyển trạng thái ${textStatusA} thành ${textStatusB} không?`,
        icon: '/media/svg/icons/SweetAlert/alert-triangle-red.svg',
        buttons: {
          cancel: {
            text: 'Hủy',
            value: false,
            visible: true,
            className: 'btn btn-secondary',
            closeModal: true,
          },
          confirm: {
            text: 'Chắc chắn',
            value: true,
            visible: true,
            className: `btn ${btn}`,
            closeModal: true,
          },
        },
      }).then(
        function (result) {
          if (result) {
            // inactive all
            this.changeStatus(item);
          }
        }.bind(this),
      );
    },
    copyItem(item) {
      this.$router.push({
        name: 'program_activity_detail',
        params: {
          form_type: 'copy',
          id: item.id,
        },
      });
    },
    async changeStatus(item) {
      this.$store.commit('context/setLoading', true);
      // Create a new FormData object
      const formData = new FormData();

      // Append properties of the item object to formData
      Object.keys(item).forEach((key) => {
        if (key == 'status') {
          formData.append('status', item.status ? '0' : '1');
        } else formData.append(key, item[key]);
      });

      // Send the FormData using the PUT method
      const res = await this.$api.delete(
        `/ProgramActivity/${item.id}`,
        formData,
      );
      const { error } = res;
      if (error) {
        this.$store.commit('context/setLoading', false);
        return this.$toastr.e({
          title: 'Lỗi !',
          msg: error.message,
        });
      }
      this.$toastr.s({
        title: 'Thành công !',
        msg: 'Cập nhật thành công',
      });
      this.$store.commit('context/setLoading', false);
      this.loadData();
    },
    async loadData() {
      try {
        this.$store.commit('context/setLoading', true);

        const { data } = await this.$api.get('ProgramActivity', {
          params: this.searchParams,
        });
        this.data =
          data.items.map((el) => ({
            ...el,
          })) || [];
        this.paging.total = data.total;
      } catch (error) {
        this.$toastr.e({
          title: 'Lỗi',
          msg: error,
        });
      } finally {
        this.$store.commit('context/setLoading', false);
      }
    },

    async loadDataReminders(id) {
      try {
        this.$store.commit('context/setLoading', true);
        const { data } = await this.$api.get(
          'ProgramActivityReminder/activity',
          {
            params: { id },
          },
        );
        this.selectedRemindersId = data;
      } catch (error) {
        this.$toastr.e({
          title: 'Lỗi',
          msg: error,
        });
      } finally {
        this.$store.commit('context/setLoading', false);
      }
    },

    async loadDataLevel() {
      try {
        this.$store.commit('context/setLoading', true);
        const data = await this.$api.get('ProgramActivityLevel/setup-list');
        this.setupData = data.data;
      } catch (error) {
        this.$toastr.e({
          title: 'Lỗi',
          msg: error,
        });
      } finally {
        this.$store.commit('context/setLoading', false);
      }
    },
    getDataHospital(tags) {
      if (!tags || !tags.length) return null;
      const agencies = tags.filter((el) => el.tag.type === TAG_TYPE.AGENCY);
      return agencies.map((el) => el.tag.name).join(', ');
    },
    getStatus(status) {
      if (status) return 'inactive';
      return 'active';
    },
    searchDebounce(value) {
      this.filter.searchText = value;
      this.resetPaging();
    },
    resetPaging() {
      this.paging.page = 1;
      this.loadData();
    },
    getSearchDataPrepare() {
      this.$api
        .get('ProgramActivity/PrepareSearchFormItem')

        .catch((error) => {
          this.$toastr.e({
            title: 'Lỗi',
            msg: error,
          });
        });
    },
  },
  async created() {
    await Promise.all([
      this.loadData(),
      this.getSearchDataPrepare(),
      this.loadDataLevel(),
    ]);
  },
};
</script>
<style lang="scss" scoped>
.status {
  padding: 6px 24px;
  color: #fff;
  text-transform: capitalize;
  width: 160px;
  text-align: center;

  &.active {
    background: #21a567;
    border-radius: 20px;
  }

  &.inactive {
    background: #ff5756;
    border-radius: 20px;
  }
}

.text-overflow {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.cell-overflow {
  max-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dropdown-form-filter {
  .dropdown-menu {
    .container {
      width: 700px;
    }
  }
}

.search-input {
  min-width: 220px;
}
</style>
